import { render } from "./PetSelectionPage.vue?vue&type=template&id=7dec0a75&scoped=true"
import script from "./PetSelectionPage.vue?vue&type=script&lang=js"
export * from "./PetSelectionPage.vue?vue&type=script&lang=js"

import "./PetSelectionPage.vue?vue&type=style&index=0&id=7dec0a75&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dec0a75"]])

export default __exports__